import { colors } from "../common/styles";

export default (theme) => ({
    margin: {
        margin: `${theme.spacing(1)} 0`,
    },
    boxForm: {
        margin: `${theme.spacing(3)} ${theme.spacing(2)}`,
    },
    makesListBgr: {
        background: colors.brightGrey,
    },
    capitalizeText: {
        textTransform: "capitalize",
    },
    identifiersWrp: {
        padding: theme.spacing(2),
        background: theme.palette.background.greyBackground,
        border: `1px solid ${theme.palette.border.darkBorder}`,
        margin: theme.spacing(2),
        borderRadius: theme.spacing(1),
    },
    //TODO: temporary solution
    list: {
        width: "100%",
        maxHeight: 400,
    },
    listItemBtn: {
        borderBottom: theme.spacing(1),
        borderColor: theme.palette.border.lightBorder,
        padding: theme.spacing(2),
    },
});
